// extracted by mini-css-extract-plugin
module.exports = {"section":"styles__section___3EJxa","boldHeading":"styles__boldHeading___1B05w","pullRight":"styles__pullRight___3D1t_"};